import { UUID } from '@/plugins/common'
import _ from 'lodash'

export default class Button {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      formDefinitionId: '',
      name: '',
      type: '',
      tip: '',
      tipsEnable: false
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/form/button.js